import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@env/environment';

import { HttpHelper } from '@app/core/helpers/http.hepler';

@Injectable()
export class PurchaseApiService {
  constructor(private http: HttpClient) {}

  stripePurchase(formData: FormData): Observable<any> {
    return this.http.post<any>(`${environment.API_URL}v5/`, formData, {
      headers: HttpHelper.setHeaders(),
    });
  }

  getTickets(url: string): Observable<any> {
    return this.http.get(url, {
      responseType: 'blob',
    });
  }

  getTaskStatus(url: string): Observable<any> {
    return this.http.get<any>(url);
  }
}
